import React, {useCallback} from 'react';
import I18n from 'app/i18n';
import openHelpDeskSupport from 'app/utils/openHelpDeskSupport';

const KnowledgeCenterSupportBlock = (): React.ReactElement => {
    const handleSupportClick = useCallback(() => {
        openHelpDeskSupport();
    }, []);

    return (
        <section className="knowledge-center__support">
            <div className="knowledge-center__support-text">
                <b>{I18n.t('knowledge_center.not_found_title')}</b>
                <span dangerouslySetInnerHTML={{__html: I18n.t('knowledge_center.not_found_description')}}/>
            </div>
            <button
                className="knowledge-center__support-btn shop-item-detail__btn"
                onClick={handleSupportClick}
            >
                {I18n.t('knowledge_center.contact_support')}
            </button>
        </section>
    );
};

export default KnowledgeCenterSupportBlock;
